import { Grid, styled } from '@mui/material';
import { Fragment } from 'react';
import AccountGroupTable from './shared/accountGroupTable';

const ContentBox = styled('div')(({ theme }) => ({
  margin: '30px',
  [theme.breakpoints.down('sm')]: { margin: '16px' }
}));

const AccountGroupMaster = () => {
  return (
    <Fragment>
      <ContentBox className='analytics'>
        <Grid container spacing={3}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <AccountGroupTable />
          </Grid>
        </Grid>
      </ContentBox>
    </Fragment>
  );
};

export default AccountGroupMaster;
